a.item.display.info = (function(){
	var my = {
		popup:function(result){
			var token = a.popup.create({
				slideFrom:'fromleft',
				title:'Show info',
				css_class:'',
				ready:function(token){
					tpl.run({
						tpl:'/tpl/item/display/info/page.ejs?v='+v,
						data:result,
						cb:function(c){
							$('#popupid_'+token+'>.ic').empty().append(c).ready(function(){
								
							});
						}
					});
				}
			});
		}
	}
	return my;
}());